import React from "react"
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Typography,
} from "@mui/material"
import StorefrontIcon from "@mui/icons-material/Storefront"
import { useTranslation } from "react-i18next"

interface OutletSelectorProps {
    outlets: Array<{ id: string; name: string }>
    selectedOutletId: string
    onChange: (outletId: string) => void
}

const OutletSelector: React.FC<OutletSelectorProps> = ({
    outlets,
    selectedOutletId,
    onChange,
}) => {
    const { t } = useTranslation()

    const handleChange = (event: SelectChangeEvent) => {
        onChange(event.target.value)
    }

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <StorefrontIcon sx={{ color: "#6366f1" }} />
            <Typography
                variant="subtitle1"
                fontWeight={600}
                sx={{ minWidth: 120 }}
            >
                {t("settings.outletSelector.label")}
            </Typography>
            <FormControl size="small" sx={{ minWidth: 280 }}>
                <InputLabel>{t("settings.outletSelector.label")}</InputLabel>
                <Select
                    value={selectedOutletId}
                    label={String(t("settings.outletSelector.label"))}
                    onChange={handleChange}
                >
                    {outlets.map((outlet) => (
                        <MenuItem key={outlet.id} value={outlet.id}>
                            {outlet.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    )
}

export default OutletSelector
